<script>
import Repositories from '@/repositories';
const OrderReceptionOrderItemsRepository = Repositories.get(
  'orderreceptionorderitems'
);
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import dateMixin from '@/mixins/dateMixin';

export default {
  components: {
    Loading,
  },
  props: {
    orderReceptionIdPublic: { type: String },
  },
  mixins: [dateMixin],
  data() {
    return {
      receivedItemsList: [],
      isLoading: false,
    };
  },
  methods: {
    modalHidden() {
      this.receivedItemsList = [];
      this.isLoading = false;
      this.$emit('modal-closed');
    },
    modalShown() {
      this.receivedItemsList = [];
      this.isLoading = true;

      OrderReceptionOrderItemsRepository.customREST
        .getByOrderReception(this.orderReceptionIdPublic)
        .then((response) => {
          this.receivedItemsList = response.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
  },
};
</script>

<template>
  <div>
    <b-modal
      id="received-items-modal"
      scrollable
      size="lg"
      :title="$t('items.items')"
      @shown="modalShown()"
      @hide="modalHidden()"
      ok-variant="danger"
    >
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#f1b44c"
        :width="70"
        :height="70"
        loader="dots"
        :is-full-page="false"
      >
      </loading>

      <table class="table table-hover table-nowrap">
        <thead class="thead-light">
          <tr>
            <th class="table-row-expandable">
              {{ $t('items.itemName') }}
            </th>
            <th class="table-row-relative">
              {{ $t('items.quantity') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="items in receivedItemsList" :key="items.idPublic">
            <td class="table-row-expandable">
              {{
                items.itemSupplierName != null &&
                items.itemSupplierName.trim().length > 0
                  ? items.itemSupplierName
                  : items.itemName
              }}
            </td>
            <td class="table-row-relative">
              {{ items.totalQuantity }}
            </td>
          </tr>
        </tbody>
      </table>

      <template #modal-footer>
        <b-button
          @click="$bvModal.hide('received-items-modal')"
          size="sm"
          variant="danger"
        >
          {{ $t('general.close') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>